if (!customElements.get('sale-timer')) {
  class SaleTimer extends HTMLElement {
    constructor() {
      super();
      this.container = this;
      
      // 🔧 Валідація та парсинг дати (фікс для iOS)
      const dateStr = this.dataset.endDate;
      if (!dateStr) {
        console.warn('SaleTimer: No endDate provided');
        return;
      }
      
      // Фікс: Конвертуємо в ISO з явним UTC (Z)
      const isoDateStr = dateStr.replace(' ', 'T') + (dateStr.includes('Z') ? '' : '.000Z'); // Якщо немає Z, додаємо
      this.endDate = new Date(isoDateStr);
      
      if (isNaN(this.endDate.getTime())) {
        console.error(`SaleTimer: Invalid endDate "${dateStr}" - use ISO like "2025-12-01T16:00:00.000Z"`);
        return;
      }
      
      // 🔧 Краща ініціалізація елементів з перевіркою
      this.elements = {
        daysElem: this.querySelector('#days'),
        hoursElem: this.querySelector('#hours'),
        minsElem: this.querySelector('#mins'),
        secsElem: this.querySelector('#secs')
      };
      
      ['daysElem', 'hoursElem', 'minsElem', 'secsElem'].forEach(key => {
        if (!this.elements[key]) console.warn(`SaleTimer: Missing ${key}`);
      });
      
      this.init();
    }

    init() {
      this._initActions();
    }

    _initActions() {
      this.updateTimer();  // Початковий апдейт
      setInterval(() => this.updateTimer(), 1000);  // Arrow fn, щоб не bind
    }

    updateTimer() {
      const now = new Date();
      const diff = this.endDate.getTime() - now.getTime();  // Використовуй .getTime() для безпеки (ms)

      if (diff <= 0) {
        this.classList.add('hidden');
        return;
      }

      // 🔧 Безпечні обчислення (використовуй getTime() для diff)
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);

      // 🔧 Додай перевірку на NaN (для дебагу)
      if (isNaN(days) || isNaN(hours) || isNaN(mins) || isNaN(secs)) {
        console.error('SaleTimer: NaN in calculations - check endDate');
        return;
      }

      this.elements.daysElem.textContent = days.toString().padStart(2, '0');
      this.elements.hoursElem.textContent = hours.toString().padStart(2, '0');
      this.elements.minsElem.textContent = mins.toString().padStart(2, '0');
      this.elements.secsElem.textContent = secs.toString().padStart(2, '0');
    }
  }

  customElements.define('sale-timer', SaleTimer);
}